import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '浏览',
    items: [
      { label: '首页', to: '/' },
      { label: '影视分类', to: '/category' },
      { label: '资讯专题', to: '/news' },
    ],
  },
  {
    title: '关于',
    items: [
      { label: '关于我们', to: '/about' },
      { label: '使用说明', to: '/about' },
      { label: '联系我们', to: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-foreground-950 text-foreground-200">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                红杏影视
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-400">
              红杏影视是一个专注于影视资讯与作品资料展示的现代门户平台，致力于为影视爱好者提供丰富的电影、电视剧资源介绍与最新影视动态，帮助你快速发现想看的作品。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-800 text-foreground-300">
                <i className="ri-wechat-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-800 text-foreground-300">
                <i className="ri-weibo-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-800 text-foreground-300">
                <i className="ri-mail-line" />
              </span>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50">{group.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {group.items.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.to}
                      className="cursor-pointer text-sm text-foreground-400 transition-colors hover:text-accent-400"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-foreground-800 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 红杏影视 Hongxing Film & TV. 本站内容仅供影视资讯展示与交流，不提供任何在线播放与下载服务。</p>
          <p>内容均为演示用途 · 版权归原权利人所有</p>
        </div>
      </div>
    </footer>
  );
}